(function () {
  if (window.__waShareCart) return;
  window.__waShareCart = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var MAX_LEN = 1800;

  // --- helpers ------------------------------------------------------------
  function config(button) {
    return {
      phone:          button.dataset.waPhone     || '',
      message:        button.dataset.waMessage   || '[link]',
      lineItem:       button.dataset.waLineItem  || '- [quantity] x [title]',
      error:          button.dataset.waErrorText || '',
      locale:         button.dataset.waLocale    || document.documentElement.lang || 'en',
      hideWhenEmpty:  button.dataset.waHideWhenEmpty !== 'false'
    };
  }

  function getCart() {
    return fetch(ROOT + 'cart.js', {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
      credentials: 'same-origin'
    }).then(function (r) {
      if (!r.ok) throw new Error('cart_fetch_failed');
      return r.json();
    });
  }

  function permalink(cart) {
    var pairs = cart.items
      .filter(function (i) { return i.variant_id && i.quantity > 0; })
      .map(function (i) { return i.variant_id + ':' + i.quantity; });
    if (!pairs.length) return null;

    var url = window.location.origin + ROOT + 'cart/' + pairs.join(',') + '?storefront=true';
    var apps = cart.cart_level_discount_applications || [];
    for (var j = 0; j < apps.length; j++) {
      if (apps[j].type === 'discount_code' && apps[j].title) {
        url += '&discount=' + encodeURIComponent(apps[j].title);
        break;
      }
    }
    return url;
  }

  function money(cents, currency, locale) {
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  function lines(cart, template) {
    return cart.items.map(function (item) {
      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? ' (' + item.variant_title + ')'
        : '';
      return replaceTokens(template, {
        quantity: item.quantity,
        title: item.product_title + variant
      });
    }).join('\n');
  }

  // Accepts BOTH [token] and {token} — fixes the mismatch between snippet
  // and section defaults.
  function replaceTokens(str, values) {
    return String(str).replace(/[\[\{](\w+)[\]\}]/g, function (_, key) {
      return values[key] !== undefined ? values[key] : '';
    });
  }

  function compose(cfg, cart, link, includeItems) {
    return replaceTokens(cfg.message, {
      items: includeItems ? lines(cart, cfg.lineItem) : '',
      count: cart.item_count,
      total: money(cart.total_price, cart.currency, cfg.locale),
      link:  link
    });
  }

  function tagCart() {
    return fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: { 'Shared to support': 'WhatsApp' } })
    }).catch(function () {});
  }

  function setError(button, text) {
    var label = button.querySelector('.wa-share-cart__label');
    button.setAttribute('data-wa-error', '');
    if (!label || !text) return;
    if (!button.dataset.waOriginalLabel) button.dataset.waOriginalLabel = label.textContent;
    label.textContent = text;
    setTimeout(function () {
      label.textContent = button.dataset.waOriginalLabel;
      button.removeAttribute('data-wa-error');
    }, 4000);
  }

  // --- click handler ------------------------------------------------------
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-wa-share-cart]');
    if (!button) return;
    event.preventDefault();

    var cfg = config(button);
    if (!cfg.phone) return;

    // Open a blank tab synchronously — iOS Safari refuses window.open after a
    // promise resolves.
    var tab = window.open('', '_blank', 'noopener,noreferrer');
    button.setAttribute('aria-busy', 'true');

    getCart()
      .then(function (cart) {
        var link = permalink(cart);
        if (!link) throw new Error('cart_empty');

        var text = compose(cfg, cart, link, true);
        if (encodeURIComponent(text).length > MAX_LEN) text = compose(cfg, cart, link, false);

        tagCart();
        var target = 'https://wa.me/' + cfg.phone + '?text=' + encodeURIComponent(text);
        if (tab && !tab.closed) tab.location.href = target;
        else window.location.href = target;
      })
      .catch(function () {
        if (tab && !tab.closed) tab.close();
        setError(button, cfg.error);
      })
      .finally(function () {
        button.removeAttribute('aria-busy');
      });
  });

  // --- visibility sync ----------------------------------------------------
  function syncVisibility() {
    var buttons = document.querySelectorAll('[data-wa-share-cart]');
    if (!buttons.length) return;
    getCart().then(function (cart) {
      Array.prototype.forEach.call(buttons, function (button) {
        if (button.dataset.waHideWhenEmpty === 'false') return;
        button.hidden = cart.item_count === 0;
      });
    }).catch(function () {});
  }

  // Listen for the theme's own cart events instead of monkey-patching fetch.
  // Multiple event names are covered because Shopify themes vary; safe to
  // listen for all of them.
  ['cart:refresh', 'cart:updated', 'cart:added', 'cart:changed', 'on:cart:refresh']
    .forEach(function (name) { document.addEventListener(name, syncVisibility); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncVisibility);
  } else {
    syncVisibility();
  }
})();